import * as STANDARD_MODULES from "@lennd/value-types/src/constants/standard-modules";

export const applications = state =>
  state.formsV2.list.forms.filter(
    f => f.module && f.module.type_id === STANDARD_MODULES.formsv3.id
  );
